<template>
  <div class="stay-up-to-date">
    <div class="stay-up-to-date-container">
      <h4>Оставайтесь в курсе новостей</h4>
      <p>Подпишитесь на нашу рассылку</p>

      <div class="stay-up-to-date-container-subscribe">
        <input type="text" placeholder="Email" class="stay-up-to-date-container-subscribe-placeholder" v-model="email">
        <button @click="sendMessage">Подписаться</button>
      </div>

      <div class="stay-up-to-date-container-policy">
        <h6>
          Нажимая «Подписаться», вы подтверждаете, что согласны на обработку персональных данных и ознакомились с
          <a href="/privacy-policy" class="privacy-policy-link" >
            политикой конфиденциальности
          </a>
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StayUpToDateUpdated',
  data() {
    return {
      email: ''
    }
  },
  methods: {
    sendMessage() {
      if (!this.email) {
        return;
      }

      fetch(`${process.env.VUE_APP_URL_DEV}/api/email/subscription/${this.email}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
          .then((response) => response.json())
          .then((result) => {
            console.log('Email sent successfully:', result);
            this.email = '';
          })
          .catch((error) => {
            console.error('Error sending email:', error);
          });
    },
  },
}
</script>

<style>
.stay-up-to-date {
  height: 302px;
  display: flex;
  justify-content: center;
  color: #23282C;
}

.stay-up-to-date-container {
  width: 1224px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.stay-up-to-date-container h4 {
  font-size: 28px;
  font-weight: 400;
  line-height: 28px;
}

.stay-up-to-date-container p {
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
}

.stay-up-to-date-container-subscribe {
  display: flex;
  height: 56px;
  gap: 8px;
  margin-top: 16px;
}

.stay-up-to-date-container-subscribe button {
  width: 146px;
  background-color: #23282C;
  color: #FFFFFF;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
}

.stay-up-to-date-container-subscribe input {
  background-color: #f0efef;
  border-radius: 4px;
}

.stay-up-to-date-container-subscribe-placeholder {
  padding-left: 20px;
  padding-top: 18px;
  padding-bottom: 18px;
  font-size: 16px;
  font-weight: 400;
  color: #7F8287;
}

.stay-up-to-date-container-policy h6 {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

.stay-up-to-date-container-policy {
  display: flex;
  justify-content: center;
  width: 601px;
  margin-top: 16px;
}

.privacy-policy-link {
  text-decoration: none;
  color: #c23132;
}
</style>
